import './execution.css'
import {Col, Row} from "react-bootstrap";
import {dayMonthYearAtTimeWithSeconds} from "../../utils/dates";
import React, {useEffect, useState} from "react";
import Notify from "../../services/Notify";
import InventoryService from "../../services/InventoryService";

function InventoryExecution({inventoryId}){

  const inventoryService = new InventoryService()

  const [executionDetails, setExecutionDetails] = useState(null)

  const getExecutionDetails = async () => {
    try {
      const response = await inventoryService.getInventoryDetails(inventoryId)
      setExecutionDetails(response)
    } catch (error) {
      Notify.error('Houve um erro ao recuperar detalhes da execução', error)
    }
  }

  useEffect(() => {
    inventoryId &&
    getExecutionDetails()
  }, [inventoryId])

  return(
    <div className="transitionDiv">
      <Row style={{paddingTop: '1rem'}}>
        <Col md={3}>
          <label className="execution-label">Executado por:</label>
        </Col>
        <Col md={3}>
          <label className="execution-label">Início de execução:</label>
        </Col>
        <Col md={3}>
          <label className="execution-label">Fim de execução:</label>
        </Col>
      </Row>
      {executionDetails && executionDetails.content.map((x, i) =>
        <Row>
          <Col md={3}>
            {x.userCreatedBy.name}
          </Col>
          <Col md={3}>
            {dayMonthYearAtTimeWithSeconds(x.createdAt)}
          </Col>
          <Col md={3}>
            {dayMonthYearAtTimeWithSeconds(x.finishDate)}
          </Col>
        </Row>
      )
      }
    </div>
  )

}
export default InventoryExecution;



// WEBPACK FOOTER //
// ./src/Inventory/components/InventoryExecution.js